// Swap-out plan for this local carousel panel: see ../README.md.
export { default as CarouselSendPanel } from './CarouselSendPanel';
export {
  CAROUSEL_WIRE_SHAPE, buildCarouselTemplateJson, parseCarouselTemplateJson,
} from './buildCarouselTemplateJson';
